import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import FloatingLabelInput from "../components/FloatingLabelInput";
import DateInput from "../components/DateInput";
import InputMask from "react-input-mask";
import { Container, Paper, Box, Grid, Typography, Checkbox, FormControlLabel, Alert, Snackbar } from "@mui/material";
import Button from "@mui/material/Button";
import { FiLoader } from "react-icons/fi";
import { HiEye, HiEyeOff } from "react-icons/hi";
import Dropdown from "../components/Dropdown";

// Helper function to calculate future date in dd-mm-yyyy format based on days input
const getFutureDate = (days) => {
    const today = new Date();
    today.setDate(today.getDate() + Number(days));
    const dd = String(today.getDate()).padStart(2, "0");
    const mm = String(today.getMonth() + 1).padStart(2, "0");
    const yyyy = today.getFullYear();
    return `${dd}-${mm}-${yyyy}`;
};

// const path = "http://103.251.218.254:3100";
const path = 'http://192.168.1.248:3101';

const categoryOptions = [
    { id: "1", name: "Admin" },
    { id: "2", name: "Team Leader" },
    { id: "3", name: "User" },
];

const UserMaster_v1 = () => {
    const navigate = useNavigate();
    const location = useLocation();
    // Expect location.state to provide mode and userId in edit mode.
    const { mode, userId } = location.state || { mode: "insert" };

    // Separate state variables for each input field.
    const [employeeName, setEmployeeName] = useState("");
    const [mobileNumber, setMobileNumber] = useState("");
    const [emailId, setEmailId] = useState("");
    const [Designation, setDesignation] = useState("");
    const [userName, setUserName] = useState("");
    const [password, setPassword] = useState("");
    const [DateOfBirth, setDateOfBirth] = useState("");
    const [joiningDate, setJoiningDate] = useState(new Date().toISOString().split("T")[0]);
    const [days, setDays] = useState("");
    // New state to control whether the "No. Days" field is enabled.
    const [enableDays, setEnableDays] = useState(false);
    const [category, setCategory] = useState("");
    const [IsActive, setIsActive] = useState(true);
    const [errors, setErrors] = useState({});
    const [updateMessage, setUpdateMessage] = useState("");
    const [updateStatus, setUpdateStatus] = useState("success");
    const [showPassword, setShowPassword] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    // NEW: State to track the original category (for edit mode).
    const [originalCategory, setOriginalCategory] = useState("");

    // Snackbar for showing team count error message.
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState("");

    // In edit mode, fetch user details and set individual states.
    useEffect(() => {
        if (mode === "edit" && userId) {
            const fetchUserDetails = async () => {
                try {
                    const response = await axios.get(`${path}/api/user/${userId}`);
                    const data = response.data;
                    console.log("Fetched user details:", data);
                    setEmployeeName(data.employeeName || "");
                    setMobileNumber(data.mobileNumber ? data.mobileNumber.toString() : "");
                    setEmailId(data.emailId || "");
                    setDesignation(data.Designation || "");
                    setUserName(data.userName || "");
                    setPassword(data.password || "");
                    setDateOfBirth(data.DateOfBirth || "");
                    setJoiningDate(data.joiningDate || new Date().toISOString().split("T")[0]);
                    const matchedOption = categoryOptions.find(
                        (option) => option.name === data.userCategory
                    );
                    setCategory(matchedOption ? matchedOption.id : "");
                    setOriginalCategory(data.userCategory);
                    // Set IsActive (if 0, then user is inactive)
                    setIsActive(data.IsActive !== undefined ? data.IsActive : true);

                    // If the user is inactive (IsActive === 0), enable freeze.
                    if (Number(data.IsActive) === 0) {
                        setEnableDays(true);
                        setDays(data.freezeDays != null ? data.freezeDays.toString() : "0");
                    } else {
                        setEnableDays(false);
                        setDays("");
                    }
                } catch (error) {
                    console.error("Error fetching user details", error);
                }
            };
            fetchUserDetails();
        }
    }, [mode, userId]);

    // Form validation.
    const validateFormData = () => {
        let newErrors = {};
        if (!employeeName.trim())
            newErrors.employeeName = "Employee Name is required";
        if (!mobileNumber.trim())
            newErrors.mobileNumber = "Mobile Number is required";
        else if (!/^\d{10}$/.test(mobileNumber))
            newErrors.mobileNumber = "Mobile Number must be 10 digits";
        if (!emailId.trim()) newErrors.emailId = "Email ID is required";
        else if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(emailId))
            newErrors.emailId = "Enter a valid email address";
        if (!Designation.trim())
            newErrors.Designation = "Designation is required";
        if (!userName.trim()) newErrors.userName = "User Name is required";
        if (!password.trim()) newErrors.password = "Password is required";
        else if (password.length < 6)
            newErrors.password = "Password must be at least 6 characters";
        if (!DateOfBirth.trim())
            newErrors.DateOfBirth = "Date of Birth is required";
        if (!joiningDate.trim())
            newErrors.joiningDate = "Joining Date is required";
        if (!category) newErrors.category = "Category is required";
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    // On form submission, build the payload.
    const handleSubmit = async (e) => {
        e.preventDefault();
        console.log("Mode:", mode, "UserId:", userId);

        // Validate form data; if invalid, exit early.
        if (!validateFormData()) return;
        setIsSubmitting(true);

        // Find the selected category object from the dropdown options.
        const selectedCategory = categoryOptions.find(option => option.id === category);

        // Build the payload with required user fields.
        const payload = {
            employeeName,
            mobileNumber,
            emailId,
            Designation,
            userName,
            password,
            DateOfBirth,
            joiningDate,
            category: selectedCategory ? selectedCategory.name : "",
            IsActive,
        };

        // In edit mode, if freeze is enabled, validate and add freezeDays and futureDate.
        if (mode === "edit" && enableDays) {
            const freezeDays = Number(days);
            if (!freezeDays || freezeDays <= 0) {
                alert("Enter a valid number of days for user disable");
                setIsSubmitting(false);
                return;
            }
            payload.freezeDays = freezeDays;
            payload.futureDate = getFutureDate(freezeDays);
        }

        console.log("Submitting payload:", payload);

        try {
            // If in edit mode and the original category is Admin, disallow changing it.
            if (mode === "edit" && originalCategory === "Admin" && selectedCategory?.name !== "Admin") {
                setSnackbarMessage("This user details cannot be modified");
                setSnackbarOpen(true);
                setIsSubmitting(false);
                return;
            }
            // In edit mode, check team count if category is being set to "User".
            if (mode === "edit" && selectedCategory?.name === "User") {
                const { data: teamData } = await axios.get(`${path}/api/teamcount/${userId}`);
                console.log(teamData);
                if (teamData.count > 0) {
                    setSnackbarMessage("Cannot change category to 'User' because this user has team members. Please remove team members before changing.");
                    setSnackbarOpen(true);
                    setIsSubmitting(false);
                    return;
                }
            }

            // Proceed with API call based on mode.
            if (mode === "edit") {
                if (!userId) {
                    setUpdateMessage("UserId is missing, cannot update");
                    setUpdateStatus("error");
                    setIsSubmitting(false);
                    return;
                }
                await axios.put(`${path}/api/useredit/${userId}`, payload);
                setUpdateMessage("User details updated successfully!");
                setUpdateStatus("success");
            } else {
                const { data: response } = await axios.post(`${path}/api/insertUser`, payload);
                if (response.success) {
                    setUpdateMessage("User created successfully!");
                    setUpdateStatus("success");
                    // Reset form fields.
                    setEmployeeName("");
                    setMobileNumber("");
                    setEmailId("");
                    setDesignation("");
                    setUserName("");
                    setPassword("");
                    setDateOfBirth("");
                    setJoiningDate(new Date().toISOString().split("T")[0]);
                    setCategory("");
                    setIsActive(true);
                    setErrors({});
                } else {
                    setUpdateMessage("Failed to create user.");
                    setUpdateStatus("error");
                }
            }
        } catch (error) {
            console.error("Error processing user details", error);
            setUpdateMessage("Server error");
            setUpdateStatus("error");
        }
        setIsSubmitting(false);
    };

    const handleCancel = () => {
        navigate("/main/v1/userdetails");
    };

    // Handle category change from the Dropdown.
    const handleCategoryChange = (selectedOption) => {
        setCategory(selectedOption.id);
    };

    return (
        <Container maxWidth="sm">
            <Paper elevation={3} sx={{ p: 4, mt: 4 }}>
                <Typography variant="h5" align="center" gutterBottom>
                    {mode === "edit" ? "Edit User Details" : "User Master"}
                </Typography>
                {updateMessage && (
                    <Alert severity={updateStatus === "success" ? "success" : "error"} sx={{ mb: 2 }}>
                        {updateMessage}
                    </Alert>
                )}
                <Box component="form" noValidate onSubmit={handleSubmit}>
                    <Grid container spacing={2}>
                        {/* Employee Name */}
                        <Grid item xs={12}>
                            <FloatingLabelInput required label="Employee Name" name="employeeName" type="text" value={employeeName} onChange={(e) => setEmployeeName(e.target.value)} error={Boolean(errors.employeeName)} helperText={errors.employeeName} />
                        </Grid>
                        {/* Mobile Number */}
                        <Grid item xs={12}>
                            <InputMask mask="9999999999" maskChar="" value={mobileNumber} onChange={(e) => setMobileNumber(e.target.value)}>
                                {(inputProps) => (
                                    <FloatingLabelInput {...inputProps} required label="Mobile No" name="mobileNumber" type="text" error={Boolean(errors.mobileNumber)} helperText={errors.mobileNumber} />
                                )}
                            </InputMask>
                        </Grid>
                        {/* Email ID */}
                        <Grid item xs={12}>
                            <FloatingLabelInput required label="Email ID" name="emailId" type="email" value={emailId} onChange={(e) => setEmailId(e.target.value)} error={Boolean(errors.emailId)} helperText={errors.emailId} />
                        </Grid>
                        {/* Designation */}
                        <Grid item xs={12}>
                            <FloatingLabelInput required label="Designation" name="Designation" type="text" value={Designation} onChange={(e) => setDesignation(e.target.value)} error={Boolean(errors.Designation)} helperText={errors.Designation} />
                        </Grid>
                        {/* User Name */}
                        <Grid item xs={12}>
                            <FloatingLabelInput required label="User Name" name="userName" type="text" value={userName} onChange={(e) => setUserName(e.target.value)} error={Boolean(errors.userName)} helperText={errors.userName} />
                        </Grid>
                        {/* Password */}
                        <Grid item xs={12}>
                            <FloatingLabelInput required label="Password" name="password" type={showPassword ? "text" : "password"} value={password} onChange={(e) => setPassword(e.target.value)} error={Boolean(errors.password)} helperText={errors.password} InputProps={{
                                endAdornment: (
                                    <Box sx={{ cursor: "pointer" }} onClick={() => setShowPassword(!showPassword)}>
                                        {showPassword ? <HiEyeOff size={20} /> : <HiEye size={20} />}
                                    </Box>
                                ),
                            }}
                            />
                        </Grid>
                        <Grid container spacing={2} sx={{ mt: 0, pl: 2, gridTemplateColumns: { xs: "1fr", sm: "1fr", md: "1fr", lg: "repeat(2, 1fr)" }, }} >
                            {/* Date of Birth */}
                            <Grid item xs={12} sx={{ width: { xs: "120%", sm: "120%", md: "100%", lg: "100%" } }}>
                                <DateInput required label="Date of Birth" name="DateOfBirth" value={DateOfBirth} onChange={(e) => setDateOfBirth(e.target.value)} error={Boolean(errors.DateOfBirth)} helperText={errors.DateOfBirth} />
                            </Grid>
                            {/* Joining Date */}
                            <Grid item xs={12} sx={{ width: { xs: "120%", sm: "120%", md: "100%", lg: "100%" } }}>
                                <DateInput required label="Joining Date" name="joiningDate" value={joiningDate} onChange={(e) => setJoiningDate(e.target.value)} error={Boolean(errors.joiningDate)} helperText={errors.joiningDate} />
                            </Grid>
                        </Grid>
                        {/* Category Dropdown */}
                        <Grid item xs={12}>
                            <Dropdown id="category" name="category" label="Category" valueKey="id" labelKey="name" value={category} options={categoryOptions} onChange={handleCategoryChange} disabled={false} fullWidth />
                            {errors.category && (
                                <Typography variant="caption" color="error">
                                    {errors.category}
                                </Typography>
                            )}
                        </Grid>
                        {/* Active Checkbox */}
                        <Grid item xs={12}>
                            <FormControlLabel
                                control={
                                    <Checkbox checked={IsActive}
                                        onChange={(e) => {
                                            const newVal = e.target.checked;
                                            setIsActive(newVal);
                                            if (newVal) setEnableDays(false);
                                        }}
                                        color="primary"
                                    />
                                }
                                label="Active"
                            />
                        </Grid>
                        {mode === "edit" && (
                            <>
                                {/* Freeze Checkbox and No. Days input */}
                                <Grid container spacing={2} alignItems="center" sx={{ pl: 2 }}>
                                    <Grid item xs={10} sm={3}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox checked={enableDays}
                                                    onChange={(e) => {
                                                        const newVal = e.target.checked;
                                                        setEnableDays(newVal);
                                                        if (newVal) setIsActive(false);
                                                    }}
                                                    color="primary"
                                                />
                                            }
                                            label="Freeze"
                                        />
                                    </Grid>
                                    <Grid item xs={10} sm={4}>
                                        <FloatingLabelInput label="No. Days" name="days" type="number" value={days} onChange={(e) => setDays(e.target.value)} disabled={!enableDays} />
                                    </Grid>
                                    <Grid item xs={10} sm={5}>
                                        <FloatingLabelInput label="Future Date" value={days ? getFutureDate(days) : ""} disabled fullWidth />
                                    </Grid>
                                </Grid>
                            </>
                        )}
                        {/* Submit & Cancel Buttons */}
                        <Grid item xs={12} container justifyContent="flex-end" spacing={2}>
                            <Grid item>
                                <Button variant="contained" color="primary" type="submit" disabled={isSubmitting}>
                                    {isSubmitting ? (
                                        <span style={{ display: "flex", alignItems: "center" }}>
                                            <FiLoader className="animate-spin" style={{ marginRight: 8 }} /> Processing...
                                        </span>
                                    ) : mode === "edit" ? "Update" : "Insert"}
                                </Button>
                            </Grid>
                            <Grid item>
                                <Button variant="contained" color="error" onClick={handleCancel}>
                                    Close
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </Box>
            </Paper>
            <Snackbar open={snackbarOpen} autoHideDuration={6000} onClose={() => setSnackbarOpen(false)} message={snackbarMessage} />
        </Container>
    );
};

export default UserMaster_v1;